"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createApolloContext = void 0;
const cookies_1 = require("../../helpers/cookies");
const createApolloClient_1 = require("../createApolloClient");
const createApolloContext = (options, context) => {
    var _a, _b;
    const { getAuthToken } = options, restOptions = __rest(options, ["getAuthToken"]);
    const isInAppContext = Boolean(context.ctx);
    const appContext = isInAppContext ? context.ctx : context;
    if (process.env.NODE_ENV === "development" && isInAppContext) {
        console.warn("Warning: You have opted-out of Automatic Static Optimization due to `withApollo` in `pages/_app`.\n" +
            "Read more: https://err.sh/next.js/opt-out-auto-static-optimization\n");
    }
    const retrieveAuthToken = (ctx) => __awaiter(void 0, void 0, void 0, function* () {
        return getAuthToken ? getAuthToken(ctx) : (0, cookies_1.getCookie)("token", ctx);
    });
    const apolloClient = (_a = context === null || context === void 0 ? void 0 : context.apolloClient) !== null && _a !== void 0 ? _a : (0, createApolloClient_1.initApolloClient)((_b = context.apolloState) !== null && _b !== void 0 ? _b : {}, Object.assign(Object.assign({}, restOptions), { getAuthToken: () => {
            return retrieveAuthToken(appContext);
        } }));
    apolloClient.toJSON = () => null;
    context.apolloClient = apolloClient;
    if (isInAppContext) {
        context.ctx.apolloClient = apolloClient;
    }
    return context;
};
exports.createApolloContext = createApolloContext;
exports.default = exports.createApolloContext;
//# sourceMappingURL=index.js.map